import * as actionTypes from "../actionTypes";
import axios from "../../../services/axios";
import {setMessage} from "../message";

export const checkCanAssignSubgroups = (payload) => {
    return {
        type: actionTypes.CAN_ASSIGN_SUBGROUPS,
        canAssignSubgroups: payload,
    };
};


export const getCanAssignSubgroups = () => {
    return (dispatch) => {
        axios
            .get(`api/v1/grade-book/is-period-expired`)
            .then((response) => {
                dispatch(checkCanAssignSubgroups(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            });
    };
};

export const loadSubgroups = () => {
    return {
      type: actionTypes.LOAD_SUBGROUPS,
    };
  };

export const setSubgroups = (payload) => {
    return {
        type: actionTypes.SET_SUBGROUPS,
        subgroups: {...payload},
    };
};


export const getSubgroups = (subjectId) => {
    return (dispatch) => {
        dispatch(loadSubgroups());
        axios
            .get(`api/v1/grade-book/subgroups?termHoursId=${subjectId}`)
            .then((response) => {
                dispatch(setSubgroups(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось получить информацию о подгруппах." }))
            });
    };
};

export const loadSubjects = () => {
    return {
      type: actionTypes.LOAD_SUBJECTS_FOR_SUBGROUPS,
    };
  };

export const setSubjects = (payload) => {
    return {
        type: actionTypes.SET_SUBJECTS_FOR_SUBGROUPS,
        subjects: [...payload],
    };
};

export const getSubjects = () => {
    return (dispatch) => {
        dispatch(loadSubjects());
        axios
            .get(`api/v1/grade-book/subgroup-subjects`)
            .then((response) => {
                dispatch(setSubjects(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось получить информацию о доступных предметах." }))
            });
    };
};

export const loadAllSubjects = () => {
    return {
        type: actionTypes.LOAD_ALL_SUBJECTS,
    };
};

export const setAllSubjects = (payload) => {
    return {
        type: actionTypes.SET_ALL_SUBJECTS,
        allSubjects: {...payload},
    };
};

export const getAllSubjects = () => {
    return (dispatch) => {
        dispatch(loadAllSubjects());
        axios
          .get(`api/v1/grade-book/subjects`)
          .then((response) => {
              dispatch(setAllSubjects(response.data));
          })
          .catch((error) => {
              dispatch(setMessage({ type: 'warning', text: "Не удалось получить информацию о доступных предметах." }))
          });
    };
};

export const loadLessonsByDate = () => {
    return {
        type: actionTypes.LOAD_LESSONS_BY_DATE
    };
};

export const setLessonsByDate = (payload) => {
    return {
        type: actionTypes.SET_LESSONS_BY_DATE,
        lessons: [...payload],
    };
};

export const getLessonsByDate = (date) => {
    return (dispatch) => {
        dispatch(loadLessonsByDate());
        axios
          .get(`api/v1/grade-book/by-date`, { params: { date } })
          .then((response) => {
              dispatch(setLessonsByDate(response.data.lessons));
          })
          .catch((_error) => {
              dispatch(setMessage({ type: 'warning', text: "Не удалось загрузить занятия за выбранную дату." }))
          });
    };
};

export const omissionUpdated = (newStudentOmissions, lessonId) => {
    return {
        type: actionTypes.UPDATE_OMISSION,
        newStudentOmissions,
        lessonId,
    };
};

export const createOmission = (newStudentOmissions, lessonId, onSaveOmissionsSuccess, onSaveOmissionsFinally) => {
    return (dispatch) => {
        const requestBody = {
            studentOmissionsHoursDtoList: newStudentOmissions,
            idLesson: lessonId,
        }
        axios.post(`api/v1/grade-book/create`, requestBody)
            .then((response) => {
                onSaveOmissionsSuccess()
                dispatch(omissionUpdated(response.data, lessonId));
            })
            .catch((_error) => {
                dispatch(setMessage({type: 'warning', text: "Не удалось выставить пропуск."}))
            })
            .finally(() => {
                onSaveOmissionsFinally();
            });
    };
};
